import { useMemo, useState } from 'react'
import { hoursToMilliseconds } from 'date-fns'
import { useGetCarListQuery } from 'store/vehicles'
import { L10N } from 'global/localization'
import { ConfirmModal } from 'shared/components/confirm-modal'
import { ButtonColor } from 'global/types/enums'
import { useNavigate } from 'react-router-dom'

const POPUP_DISMISSED_AT = 'inAppPopupDismissedAt'
const POPUP_START_DATE = process.env.REACT_APP_POPUP_START_DATE!
const POPUP_END_DATE = process.env.REACT_APP_POPUP_END_DATE!

export default function InAppPopup() {
  const navigate = useNavigate()

  const { data: cars, isLoading: isLoadingCars } = useGetCarListQuery()
  const [now, _] = useState(Date.now())
  const [dismissedAt, setDismissedAt] = useState<number | null>(
    localStorage.getItem(POPUP_DISMISSED_AT)
      ? Number(localStorage.getItem(POPUP_DISMISSED_AT))
      : null
  )

  const content = L10N.MESSAGE.IN_APP_POPUP_CONTENT
  const title = L10N.MESSAGE.IN_APP_POPUP_TITLE
  const intervalInHours = 24

  const sixMonthsFromNow = useMemo(() => {
    const x = new Date()
    x.setMonth(x.getMonth() + 6)
    return x
  }, [now])

  const isSubsEnding = useMemo(
    () =>
      cars?.data?.some((c) => {
        const expiredAt = Date.parse(c.subscriptionExpiredDate)
        if (isNaN(expiredAt)) return false

        return expiredAt < sixMonthsFromNow.getTime()
      }),
    [cars, sixMonthsFromNow]
  )

  const isSeen = useMemo(() => {
    if (!dismissedAt) return false
    const msSinceDismissal = Date.now() - dismissedAt
    return msSinceDismissal < hoursToMilliseconds(intervalInHours)
  }, [dismissedAt])

  const isWithinTimeRange = Date.parse(POPUP_START_DATE) <= now && now <= Date.parse(POPUP_END_DATE)

  const isValid = isSubsEnding && !isSeen && isWithinTimeRange

  function handleClose() {
    setDismissedAt(Date.now())
    localStorage.setItem(POPUP_DISMISSED_AT, Date.now().toString())
    navigate('/home')
  }

  const desc = content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : null

  return (
    <ConfirmModal
      title={title || ''}
      desc={desc}
      open={!!isValid}
      onConfirm={handleClose}
      onCancel={handleClose}
      cancelText={L10N.LABEL.LATER}
      confirmText={L10N.LABEL.OK_RENEW}
      confirmColor={ButtonColor.Primary}
    />
  )
}
